import { Component, Input } from '@angular/core';
import { ShareDialogComponent } from '../share-dialog/share-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { StreappEvent } from 'src/app/models/streappevent.model';
import { MediaItem, MediaType } from 'src/app/models/mediaitem.model';

const DEFAULT_COPY_BUTTON_TEXT = 'copy_link.copy_selectedMediaItem';

@Component({
    selector: 'share-button',
    templateUrl: './share-button.component.html',
    styleUrl: './share-button.component.scss',
    standalone: false
})
export class ShareButtonComponent  {
  @Input() event: StreappEvent;
  @Input() isMyStreApp: boolean;
  @Input() selectedMediaItem: MediaItem;

  MediaType = MediaType;
  copyButtonText: string = DEFAULT_COPY_BUTTON_TEXT;

  constructor(
    private readonly dialog: MatDialog,
  ) {}

  download() : void {
    window.open(this.selectedMediaItem.url, '_blank');
  }

  share(): void {
        this.dialog.open<ShareDialogComponent>(
          ShareDialogComponent,
          {
            autoFocus: false, // To prevent select state of close button in header
            data: {
              url: window.location.href,
              title: this.event.title,
              instagram: true,
              facebook: true,
              x: true
            }
          }
        );
  }

  copy(): void {
    if (!this.selectedMediaItem.url) {
      return;
    }

    navigator.clipboard
      .writeText(this.selectedMediaItem.url)
      .then(() => {
        // Update the button text or state to indicate success if needed
        // For example, you could change the button text to "Copied!" temporarily
        this.copyButtonText = 'copy_link.copy_success';
        setTimeout(() => {
          // Reset the button text after a short delay
          this.copyButtonText = DEFAULT_COPY_BUTTON_TEXT;
        }, 5000);
      })
      .catch((err) => {
        // Optionally, you can show an error message here
        console.error('Failed to copy link: ', err);
      });
  }
}
